import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import LightModeIcon from "@mui/icons-material/LightMode";
import {
  Box,
  IconButton,
  Stack,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { Spacer, ThemeModeSwitcher } from "common";
//@ts-ignore
import { ReactComponent as SvgMobileLogo } from "assets/logo.svg";
import CopyRight from "components/CopyRight/CopyRight";
import AddToHomeScreen from "features/waivers/submit/AddToHomeScreen";
import I18n from "i18n-js";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
const MobileLogo = styled(SvgMobileLogo)`
  width: 36px;
  height: 36px;
`;

export default function PublicLayout() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const theme = useTheme();
  // Watch for fullscreenchange
  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener("fullscreenchange", onFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);
  return (
    <Box
      sx={{
        //display: "flex",
        flex: 1,
        /*alignItems: "center",
        justifyItems: "center",
        alignContent: "center",
        backgroundColor: "red",
        justifyContent: "center",*/
        p: 3,
        overflow: "auto",
        //backgroundColor: "secondary.main",
        //height: "100vh",
        //backgroundPosition: "50% 50%",
      }}
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <MobileLogo
          style={{ color: theme.palette.mode === "dark" ? "white" : "#001e3c" }}
        />
        <Typography variant="h4" noWrap component="div">
          {I18n.t("App.title")}
        </Typography>
        <Spacer right />
        {!(window as any)._isApp && (
          <>
            <AddToHomeScreen />
            <IconButton
              title={isFullscreen ? "Exit fullscreen" : "Fullscrren"}
              onClick={() =>
                isFullscreen
                  ? document.exitFullscreen()
                  : document.body.requestFullscreen()
              }
            >
              {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
          </>
        )}
        <LightModeIcon fontSize="small" />
        <ThemeModeSwitcher size="small" />
      </Stack>
      <Spacer h={2} />
      <Outlet />
      <Spacer h={2} />
      <CopyRight />
    </Box>
  );
}
